import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">SoCal Patriot</p>
        <h1>Your Trusted Source for Local Insights</h1>
        <p className="lede">
          Discover the heart of Southern California with SoCal Patriot. We provide you with the latest news, events, and community highlights to keep you informed and engaged.
        </p>
        <div className="cta-row">
          <a href="/about" target="_self">
            Learn More About Us
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Stay Informed</h2>
          <p>
            Get the latest updates on local news and events that matter to you. Our dedicated team curates content to keep you connected with your community.
          </p>
        </article>
        <article>
          <h2>Engage with Your Community</h2>
          <p>
            Join discussions, share your thoughts, and participate in local events. SoCal Patriot is your platform for community engagement and connection.
          </p>
        </article>
        <article>
          <h2>Explore Local Culture</h2>
          <p>
            From hidden gems to popular attractions, discover the diverse culture and vibrant lifestyle of Southern California. Your adventure starts here.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;